import React from 'react'
import MissionValueLeftImage from '@/assets/about-us/mission_values.webp'
import ZapImage from '@/assets/about-us/zap.png'
import CodepenImage from '@/assets/about-us/codepen.png'
import Pill from '@/components/base/Pill'
import Image from 'next/image'
import { Col, Row } from 'react-bootstrap'
import { HiOutlineLightningBolt } from 'react-icons/hi'

const MissionValues = () => {
	return (
		<div className='about-mission-values'>
			<div className='about-mission-heading'>
				<Pill icon={<HiOutlineLightningBolt />} text='Mission + Values' type='tertiary' />
				{/* <p>
        We are a group of Industry and Technology professionals {" "}
          <span>
          who are passionate about building solutions for the digitization of <br/>Metal Supply Chain.
          </span>
        </p> */}
			</div>
			<Row className='about-mission-content'>
				<Col xs={12} md={12} lg={6}>
					<Image id='mission-value-left-image' src={MissionValueLeftImage} alt='..' />
				</Col>
				<Col xs={12} md={12} lg={6}>
					<div className='about-mission-content-right'>
						<div className='about-content-box'>
							<div className='d-flex w-100 align-items-center'>
								<Image src={ZapImage} alt='..' />
								<h3 className='ms-2'>Our Mission</h3>
							</div>
							<p>
								Our mission is to be the leading provider of Metal Supply Chain digital solutions, offering fulfillment, fabrications, competitive prices and credit solutions.
								We are committed to fostering enduring partnerships with
								suppliers and customers, driving innovation, and promoting sustainability throughout our operations.
							</p>
						</div>
						<div className='about-content-box'>
							<div className='d-flex w-100 align-items-center'>
								<Image src={CodepenImage} alt='..' />
								<h3 className='ms-2'>Our Values</h3>
							</div>
							<p>
								The core values of Metalbook revolve around innovation, user-centricity, agility, transparency and strong governance. 
								Empowering our employees and fostering a culture of diversity and inclusion are of utmost importance. 
								Sustainability is integrated into business practices, and data-driven decision-making informs strategies.
							</p>
						</div>
					</div>
				</Col>
			</Row>
		</div>
	)
}

export default MissionValues
